import React from 'react';
import { InfoIcon, CheckCircleIcon, AlertTriangleIcon, XCircleIcon } from 'lucide-react';
interface MessageBarProps {
  type?: 'info' | 'success' | 'warning' | 'error';
  title?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}
export const MessageBar: React.FC<MessageBarProps> = ({
  type = 'info',
  title,
  children,
  action,
  className = ''
}) => {
  const styles = {
    info: 'bg-status-info-bg border-status-info/20 text-status-info',
    success: 'bg-status-success-bg border-status-success/20 text-status-success',
    warning: 'bg-status-warning-bg border-status-warning/20 text-status-warning',
    error: 'bg-status-error-bg border-status-error/20 text-status-error'
  };
  const icons = {
    info: <InfoIcon className="w-5 h-5" data-id="element-211" />,
    success: <CheckCircleIcon className="w-5 h-5" data-id="element-212" />,
    warning: <AlertTriangleIcon className="w-5 h-5" data-id="element-213" />,
    error: <XCircleIcon className="w-5 h-5" data-id="element-214" />
  };
  return <div className={`flex items-start gap-3 p-4 border rounded-fluent ${styles[type]} ${className}`} data-id="element-215">
      <div className="flex-shrink-0 mt-0.5" data-id="element-216">{icons[type]}</div>
      <div className="flex-1" data-id="element-217">
        {title && <h4 className="font-semibold mb-1 text-text-primary" data-id="element-218">{title}</h4>}
        <div className="text-sm text-text-primary" data-id="element-219">{children}</div>
      </div>
      {action && <div className="flex-shrink-0 ml-4" data-id="element-220">{action}</div>}
    </div>;
};